// b"KEM"
export const SUITE_ID_HEADER_KEM = new Uint8Array([
    75,
    69,
    77,
    0,
    0,
]);
